import { FooterAvatarText } from '../style';
import { CustomerBody, CustomerWrapper } from './style';
import React from 'react';
export var CustomerAvatar = function (_a) {
    var initials = _a.initials, isFooter = _a.isFooter;
    return (React.createElement(CustomerWrapper, { isFooter: isFooter },
        React.createElement(CustomerBody, { align: "center", color: "shade.0", isFooter: isFooter },
            React.createElement(FooterAvatarText, { isFooter: isFooter }, initials))));
};
//# sourceMappingURL=index.js.map